<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">

      <div class="view__panel">
        <div class="form js-form">
          <submenu></submenu>

          <TextBox
            label="Label_EmailAddress"
            v-model="model.emailAddress"
            :validate="$v.model"
            @input="$v.model.emailAddress.$touch"
            placeholder="Placeholder_Email"
            modelPath="emailAddress"
            acc="emailAddress"
          />

          <TextBox
            label="Label_Password"
            v-model="model.password"
            :validate="$v.model"
            @input="$v.model.password.$touch"
            modelPath="password"
            acc="password"
            type="password"

            v-if="createMode"
          />

          <TextBox
            label="Label_ConfirmPassword"
            v-model="model.confirmPassword"
            :validate="$v.model"
            @input="$v.model.confirmPassword.$touch"
            modelPath="confirmPassword"
            acc="confirmPassword"
            type="password"

            v-if="createMode"
          />

          <CheckBox v-model="model.isActive" label="Label_IsActive" acc="isActive" />

          <CheckBox
            v-model="model.isEmailConfirmed"
            label="Label_IsEmailConfirmed"
            acc="isEmailConfirmed"
            v-if="!createMode"
          />

          <Btn :isLoading="loading" v-on:click="save" label="Label_SaveButton" />
          <Btn v-on:click="$router.push({name: 'users'})" label="Label_CancelButton" :withBorder="true" />
          <Btn v-if="!createMode && !user.isEmailConfirmed" @click="resendConfirmEmail" label="ResendConfirmEmail" float="right" :withBorder="true" />
        </div>
      </div>
    </article>

  </article>
</template>

<script>
import { TextBox, Btn, CheckBox } from 'components/layout/forms'
import Submenu from 'components/views/account/Submenu'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'
import { required, sameAs } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'
const userService = window.abp.services.app.user

export default {
  name: 'user',
  components: { Submenu, Validation, TextBox, Btn, CheckBox },
  mixins: [notifications],
  data() {
    return {
      L: L,
      loading: false,
      title: L.localize('Label_Create'),
      model: {
        id: '',
        emailAddress: '',
        isActive: true,
        isEmailConfirmed: false,
        password: '',
        confirmPassword: ''
      }
    }
  },
  validations: {
    model: {
      emailAddress: { required },
      password: {
        required (value) {
          return this.requiredIfCreateMode(value)
        }
      },
      confirmPassword: {
        requiredIfCreateMode (value) {
          return this.requiredIfCreateMode(value)
        },
        sameAs: sameAs('password')
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch('getUser', this.$route.params.id).then(() => {
      this.mapFromState()
    })
  },
  computed: {
    ...mapGetters({
      user: 'activeUser'
    }),
    createMode() {
      if (this.user) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    resendConfirmEmail() {
      userService.sendConfirmationEmail(this.user.id).then(() => {
        this.showNotification({
          title: L.localize('Label_SuccessCreation'),
          message: L.localize('Label_Success')
        })
      })
    },
    requiredIfCreateMode(value) {
      if (this.createMode && value === '') {
        return false
      }
      return true
    },
    mapFromState() {
      _.assign(this.model, this.user)
      if (this.user) {
        this.title = this.user.emailAddress
      }
      if (!this.createMode) {
        this.model.confirmPassword = this.model.password
      }
    },
    save() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return;
      }
      this.loading = true
      let user = this.model
      this.$store.dispatch('createOrUpdateUser', user).then(
        // resolve
        () => {
          this.loading = false
          if (user.id === '') {
            this.$router.push({name: 'user', params: { id: this.user.id }})
            this.showNotification({
              title: L.localize('Label_SuccessCreation'),
              message: L.localize('Label_Success')
            })
          } else {
            this.mapFromState()
            this.showNotification({
              title: L.localize('Label_SuccessEdit'),
              message: L.localize('Label_Success')
            })
          }
        },
        // reject
        () => {
          this.loading = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// User.vue?57a1da0a